export default {
  'Submit': 'Invia',
  'Save': 'Salva',
  'enterOTP': 'Conferma il tuo numero di telefono',
  'otpSent': 'Password OTP inviata',
  'login/signup': 'Accedi/Registrati',
  'resendCode': 'Invia di nuovo il codice',
  'edit': 'Modifica',
  'otpMessage': 'È stato inviato un codice a 6 cifre al tuo cellulare',
  'oyo360WelcomeMessage': 'Ti diamo il benvenuto a OYO',
  'oyo360ResendCode': 'Invia di nuovo il codice',
  'oyo360Edit': 'Modifica',
  'oyo360otpMessage': 'Inserisci il codice che abbiamo inviato tramite SMS al tuo numero di cellulare',
  'buttonActionContinue': 'Continua',
  'chooseLanguage': 'Scegli una lingua',
  'currentLanguage': 'LINGUA ATTUALE',
  'otherLanguages': 'ALTRE LINGUE',
  'google': 'Continua con Google',
  'facebook': 'Continua con Facebook',
  'or': 'o ',
  'buttonActionSubmit': 'Invia',
  'welcomeTitle': 'OYO ti dà il benvenuto',
  'welcomeHeadingForMailLogin': `Inserisci l'indirizzo email che hai registrato con noi`,
  'welcomeHeadingForPhoneLogin': 'Inserisci il numero di telefono cellulare registrato con noi',
  'emailIdLabel': 'Indirizzo email',
  'phoneNumberLabel': 'Numero di telefono',
  'passwordLabel': 'Password',
  'newPasswordLabel': 'Nuova password',
  'confirmNewPasswordLabel': 'Conferma nuova password',
  'emailErrorMessage': `Per favore, inserisci l'indirizzo email corretto`,
  'phoneNumberErrorMessage': 'Per favore, inserisci il numero di telefono corretto',
  'passwordErrorMessage': 'Per favore, inserisci la password corretta',
  'confirmPasswordErrorMessage': 'La password non coincide!',
  'generateNewPassword': 'Crea una nuova password',
  'loginButtonLabel': 'Accedi ',
  'loginWithPhoneButtonLabel': 'Continua con il telefono',
  'loginWithOtp': 'Accedi con il codice di verifica',
  'loginWithEmailButtonLabel': `Continua con l'indirizzo email`,
  'back': 'Indietro',
  'loginWithOtpTitle': 'Inserisci codice di verifica',
  'loginWithOtpHeading': 'È stato inviato un codice a 6 cifre al tuo telefono',
  'listYourProperty': 'Pubblica la tua casa',
  'privacyPolicy': `l'Informativa sulla privacy`,
  'verifyEmail': 'Verifica indirizzo email',
  'verifyMobile': 'Verifica numero di telefono',
  'forgotPasswordPhoneSubHeading':
    'Ti invieremo un codice di verifica a 6 cifre per verificare il tuo numero di telefono',
  'forgotPasswordMailSubHeading': 'Ti invieremo un codice di verifica a 6 cifre per verificare il tuo indirizzo email',
  'newPasswordCondition1': 'Dovrebbe avere sia numeri che simboli',
  'newPasswordCondition2': 'Dovrebbe avere almeno 8 caratteri',
  'newPasswordCondition3': 'Dovrebbe avere sia minuscole che maiuscole',
  'confirmLogin': 'Conferma e accedi',
  'getOTP': 'Ottieni codice di verifica',
  'invalidInput': 'Inserimento non valido',
  'passwordResetMessage': 'Password generata con successo',
  'otpErrorMessage': 'Per favore, inserisci il corretto codice di verifica',
  'resendOtpSuccessMessage': 'Il codice di verifica è stato inviato di nuovo con successo al tuo numero di telefono',
  'InternalServerErrorMessage': 'Errore interno del server',
  'resetPasswordHeading': 'È stato inviato un codice a 6 cifre alla tua email e numero di telefono',
  'signingIn': 'Accesso in corso',
  'invalidMobileNumber': 'Numero di telefono non valido',
  'privacyFooterText': `Accedendo al tuo account, accetti le nostre {termsOfUse} e {privacyPolicy}`,
  'and': 'e',
  'termsOfUse': `Termini d'uso`,
  'listProperty': 'Pubblica la tua casa',
  'whiteSpace': ' ',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'mobileNumberPlaceholder': 'Inserisci il numero di telefono',
  'loginSubText': 'Inserisci il tuo numero di telefono per diventare una casa vacanze Belvilla in soli 30 minuti',
  'termsOfService': 'Termini di servizio',
  'termsOfServiceFooter': 'Selezionando Continua di seguito, accetto i seguenti {termsOfService}',
  'secureInformation': 'Non preoccuparti, le tue informazioni sono al sicuro con noi',
  'mobileSearchPlaceholder': 'Ricerca',
  'passwordChangeInformationText': 'Dopo la modifica della password, verrai disconnesso da tutti i dispositivi.'
};
